import { csx } from '@vtex/admin-ui'

const styles = {
  alert: csx({
    marginTop: '$space-5',
    height: 'fit-content',
  }),
}

export default styles
